import SvgArrow from '@img/icons/chevron-right.svg';
import { FocusRing } from '@react-aria/focus';
import * as React from 'react';
import S from '../Button/Button.styles';
const LinkButton = ({ buttonType, children, icon, iconOnly, iconPosition = 'right', ...otherProps }) => {
    return (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
        React.createElement(S.Container, { as: "a", "data-icon-only": iconOnly, "data-icon-position": iconPosition, "data-type": buttonType, ...otherProps },
            React.createElement(S.Text, null, children),
            React.createElement(S.IconWrapper, null, icon ?? React.createElement(SvgArrow, null)))));
};
export default LinkButton;
